import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useMemo } from "react";
import { ChecklistServico } from "../../../../domain/models/checklist_servico";
import { FormSwitchInput } from "../../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { DefaultFormSelectInput } from "../../../../../../common/components/default_form_select_input";
import { ChecklistServicoForm, ChecklistServicoSchema, initialChecklistServicoForm } from "../../../schemas/ChecklistServico_lista/checklist_servico";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";

/**
 * ChecklistServicoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedChecklistServico: ChecklistServico | null,
  onClose: (idChecklistServico: number | null, openState: boolean) => void;
  onSubmit: (form: ChecklistServicoForm) => void;
};

export const ChecklistServicoModal = ({
  open,
  saving,
  loading,
  selectedChecklistServico,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ChecklistServicoSchema),
  });

  const tipoServico = useMemo(() => {
    return [
      { id: 0, label: 'Controlado' },
      { id: 1, label: 'Especializado' },
    ];
  }, [
  ]);

  useEffect(() => {
    if (open) {
      if (selectedChecklistServico) {
        hookForm.setValue('ativo', selectedChecklistServico.status === 0);
        hookForm.setValue('codigo', selectedChecklistServico.codigo ?? '');
        hookForm.setValue('nroRevisao', selectedChecklistServico.revisao ?? '');
        hookForm.setValue('descricao', selectedChecklistServico.descricao ?? '');
        hookForm.setValue('unidade', selectedChecklistServico.unidade ?? '');
        hookForm.setValue('tipoServico', selectedChecklistServico.tipoServico === 'C' ? 0 : 1);
        hookForm.setValue('campo1', selectedChecklistServico.campo1 ?? '');
        hookForm.setValue('campo2', selectedChecklistServico.campo2 ?? '');
        hookForm.setValue('campo3', selectedChecklistServico.campo3 ?? '');
        hookForm.setValue('campo4', selectedChecklistServico.campo4 ?? '');
      } else {
        hookForm.reset({
          ...initialChecklistServicoForm,
        });
      }
    }
  }, [
    open,
    selectedChecklistServico,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="50rem"
      title='Checklist de serviço'
      onClose={() => onClose(null, false)}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col">
        <FormContainer title='Informações' arrangement='fullRow' paddingTop="small" paddingBottom="normal" gap='small' border={false}>
          <>
            <FormSwitchInput
              name='ativo'
              readOnly={saving}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='codigo'
              label='Código do Checklist'
              readOnly={saving}
              required={true}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='nroRevisao'
              label='Nº da revisão'
              readOnly={saving}
              required={true}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='descricao'
              label='Descrição do Checklist'
              readOnly={saving}
              required={true}
              multiline={true}
              rows={5}
              reactHookForm={hookForm}
            />

            <DefaultFormSelectInput
              name='tipoServico'
              label='Tipo de Serviço'
              options={tipoServico}
              required={true}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='unidade'
              label='Unidade de Medição'
              reactHookForm={hookForm}
            />

          </>
        </FormContainer>

        <FormContainer title="Critérios de Localização da Inspeção" gap="small" paddingBottom="normal" arrangement="fullRow">
          <>
            <DefaultFormInput
              name='campo1'
              label='Campos 1'
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='campo2'
              label='Campos 2'
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='campo3'
              label='Campos 3'
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='campo4'
              label='Campos 4'
              reactHookForm={hookForm}
            />
          </>
        </FormContainer>
      </div>
    </BaseFormControlledModal >
  );
}